export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  BILLING_UPDATED: 'BILLING_UPDATED',
  BILLING_LIMIT_REACHED: 'BILLING_LIMIT_REACHED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  // Disparado pelo menu de acoes da conversa. Quem abre o modal e a caixa de
  // resposta, que tem o texto digitado em maos — o rascunho no store nao serve
  // aqui porque o autosave e leading-only e a ultima rajada digitada ainda nao
  // foi gravada.
  SCHEDULE_MESSAGE: 'scheduleMessage',
  KANBAN_CARDS_REFRESH_REQUESTED: 'kanbanCardsRefreshRequested',
  // Menção ao usuário logado no chat interno (#1784): o actionCable.js emite, o MentionToasts.vue
  // decide se avisa.
  INTERNAL_CHAT_MENTIONED: 'internalChatMentioned',
  // O celular revelado pela Apollo chegou (ou não vai chegar) — #1514. Vai por emitter e não por
  // Vuex porque quem precisa dele é UMA tela, a ficha da empresa que está aberta esperando.
  FLIP_LEADS_REVELACAO_UPDATED: 'FLIP_LEADS_REVELACAO_UPDATED',
};
